<template>
  <div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-2">
            <label>Período</label>
            <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :showIcon="true" :manualInput="false" 
            :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>				
        </div> 
        <div class="p-field p-col-12 p-md-5">
            <label>Empresa</label>
            <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                @change="listarCentrosCustos"/>
        </div>
        <div class="p-field p-col-12 p-md-3">
            <label>Centro de custo</label>
            <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" dataKey="id" placeholder="Selecione"
                :filter="true" :showClear="true"/>
        </div> 
        <div class="p-field p-col-0">
            <label style="color:#ffffff">.</label>  
            <Button label="Buscar" icon="pi pi-search" @click="atualizarPorFiltros('BUCAR_COM_CENTRO_CUSTO')"/>
        </div>                                 
    </div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">                           
            <div class="p-field-checkbox">
                <Checkbox v-model="ativo" :binary="true"/>
                <label>Ativo</label>
            </div>
        </div>
        <div class="p-field p-col-12 p-md-4" :class="suporteOnline ? 'p-md-4' : 'p-md-5'">
            <div class="p-inputgroup">
                <InputText v-model.trim="crachaNome" 
                @keyup.enter="atualizarPorFiltros('PESQUISAR')"
                @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')" 
                placeholder="crachá/pis/cpf/nome"/>
                <Button icon="pi pi-search" title="Pesquisar" @click="atualizarPorFiltros('PESQUISAR')"/>                    
            </div>
        </div>
        <div class="p-field p-col-auto" v-if="suporteOnline">
            <Button class="p-button-success" icon="pi pi-filter" 
            title="Filtrar Funcionário com Pontos duplicados" 
            @click="exibirAnalisePontoDuplicado()"/>   
        </div>                                
    </div>

    <DataTable :value="periodosControle" class="p-datatable-sm p-datatable-striped">                     
        <Column field="funcionario.crachaFormatado" header="Crachá"></Column>
        <Column field="funcionario.nome" header="Nome">
            <template #body="slotProps">
                <label>{{ slotProps.data.funcionario.nome }}</label>
                <i v-if="slotProps.data.temPendencias" class="pi pi-exclamation-circle ik-text-warnning p-ml-2" 
                    style="font-size: 2rem;" title="Solicitações pendentes"></i>
            </template>
        </Column>
        <Column field="totalDivergencias" header="Divergências">
            <template #body="slotProps">                                    
                <div>                                      
                    <span v-if="slotProps.data.qtdFaltas > 0" title="Falta" style="background:#ec6231" class="p-badge p-badge-lg">{{ slotProps.data.qtdFaltas }}</span> 
                    <span v-if="slotProps.data.qtdAtrasos > 0" title="Atraso" class="p-badge p-badge-lg p-badge-secondary p-ml-1">{{ slotProps.data.qtdAtrasos }}</span> 
                    <span v-if="slotProps.data.qtdExcessoRefeicao > 0" title="Excesso no intervalo" style="background:#f29472" class="p-badge p-badge-lg p-ml-1">{{ slotProps.data.qtdExcessoRefeicao }}</span> 
                    <span v-if="slotProps.data.qtdSaidasAntecipadas > 0" title="Saída antecipada" class="p-badge p-badge-lg p-badge-warning p-ml-1">{{ slotProps.data.qtdSaidasAntecipadas }}</span> 
                    <span v-if="slotProps.data.qtdFaltaMarcacao > 0" style="background:#8E469D" title="Falta de marcação" class="p-badge p-badge-lg p-ml-1">{{ slotProps.data.qtdFaltaMarcacao }}</span> 
                    <span v-if="slotProps.data.qtdInterjornada > 0" title="Interjornada" class="p-badge p-badge-lg p-badge-danger p-ml-1">{{ slotProps.data.qtdInterjornada }}</span>                                     
                </div>
            </template>
        </Column>
        <Column field="fechado" header="Status">
            <template #body="slotProps">                                    
                <div>                                        
                    <span class="p-badge p-badge-lg p-badge-secondary" title="Fechado para cálculos" v-if="slotProps.data.fechado" >
                        <i style="color:#F9B720" class="pi pi-lock" ></i>                                       
                    </span>
                    <span class="p-badge p-badge-lg p-badge-success" title="Aberto para cálculos" v-else>                                          
                        <i class="pi pi-lock-open"></i>
                    </span>                                        
                </div>
            </template>                                
        </Column>	
        <Column>
            <template #body="slotProps">
                <Button icon="pi pi-eye" label="Marcações" title="Marcações" class="p-button-rounded p-button-info" @click="marcacoes(slotProps.data)"/>                                    
            </template>
        </Column>		
    </DataTable>

    <Paginacao ref="paginacao" :qtdLinhasPorPagina="[10,15,20,30]" :callback="atualizarPorPagina"/>

    <AnalisePontoDuplicado ref="formAnalisePontoDuplicado" />
    
  </div>
</template>

<script>
import CentroCustoService from '@/service/CentroCustoService';
import AnalisePontoDuplicado from '@/components/pages/movimento/analisePontoDuplicado/AnalisePontoDuplicado.vue';
import Paginacao from '@/components/template/Paginacao.vue';
import ControlePontoService from '@/service/ControlePontoService';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters, mapActions } from 'vuex';

export default {
    centroCustoService: null,
    controlePontoService: null,
    data() {
        return {        
            idCnpjSelecionado: null,
            cnpjs: [],
            periodosControle: [],
            idCentroCustoSelecionado: null,            
            centrosCustos: [],           
            crachaNome: '',
            ativo: true,
            mesAno: new Date(),
            rangeData: '',
            qtdLinhasPorPagina: 10,
            numPagina: 1,
            localeCalendarBR: localeCalendarBR,
            btnClick: '',
            suporteOnline: false,
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao', 'getCacheEmpresa']),
        ...mapActions('funcionario', ['inluirDadosMarcacoes', 'limparDadosFuncionario']),
        ...mapActions('sessao', ['atualizarCacheEmpresa']),
        
        exibirAnalisePontoDuplicado() {   
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }        
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }
            let cnpj = null;
            this.cnpjs.forEach(item => {
                if(item.id == this.idCnpjSelecionado) {
                    cnpj = item;
                }
            });
            let requisicao = {
                crachaNome: this.crachaNome,
                qtdLinhas: this.qtdLinhasPorPagina,
                numPagina: this.numPagina,
                mes: this.mesAno.getMonth()+1,
                ano: this.mesAno.getFullYear(),
                mesAno: this.mesAno,
                ativo: this.ativo,
                cnpj: {...cnpj},
                idsCentrosCustos: idsCentrosCustos,
                usuarioRequisicao: {...this.getDadosRequisicao()},
            }
            this.atualizarCacheDados(0);
            this.$refs.formAnalisePontoDuplicado.iniciar(requisicao);
        },

        atualizarPorPagina(paginacao) {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            this.numPagina = paginacao.pagina;
            this.qtdLinhasPorPagina = paginacao.linhas;      
            this.buscar();      
        },
        atualizarPorFiltros(btn) {
            if(btn == 'BUCAR_COM_CENTRO_CUSTO' && this.idCentroCustoSelecionado == null) {
                exibirMensagemSis(this, 'Selecione um Centro de Custo', true);
                return;
            } else if(btn == 'PESQUISAR' && !this.crachaNome) {
                exibirMensagemSis(this, 'Informe um crachá ou nome para a pesquisa', true);
                return;
            }       
            this.btnClick = btn;
            this.numPagina = 1;
            this.$refs.paginacao.paginar(1);            
        },
        buscar() {            
            let pesquisaCrachaNome = this.crachaNome;
            if(this.btnClick == 'PESQUISAR') {
                // Pesquisar em todos centros de custos do usuário.
                this.idCentroCustoSelecionado = null;
            } else {
                pesquisaCrachaNome = '';
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }
            let cnpj = null;
            this.cnpjs.forEach(item => {
                if(item.id == this.idCnpjSelecionado) {
                    cnpj = item;
                }
            });
            let requisicao = {
                crachaNome: pesquisaCrachaNome,
                qtdLinhas: this.qtdLinhasPorPagina,
                numPagina: this.numPagina,
                mes: this.mesAno.getMonth()+1,
                ano: this.mesAno.getFullYear(),
                ativo: this.ativo,
                cnpj: {...cnpj},
                idsCentrosCustos: idsCentrosCustos,
                usuarioRequisicao: {...this.getDadosRequisicao()},
            }
            this.controlePontoService.buscar(requisicao)
            .then(resp => {  
                this.$refs.paginacao.atualizar(resp.data.qdtFuncionarios);
                this.periodosControle = resp.data.periodosControle;                
                this.periodosControle.forEach(periodo => {
                    this.formatarCracha(periodo.funcionario);
                });               
                this.atualizarCacheDados(resp.data.qdtFuncionarios);
            })
            .catch(erro => { exibirMensagem(this, erro)});     
        },
        marcacoes(periodoControle) {
            let cnpj = null;
            this.cnpjs.forEach(item => {
                if(item.id == this.idCnpjSelecionado) {
                    cnpj = item;
                }
            });
           let dados = {
               mesAno: this.mesAno,
               funcionario: periodoControle.funcionario,
               cnpj: cnpj
            };
            this.inluirDadosMarcacoes(dados);
            this.$router.push('/movimento/controle-ponto/marcacoes');
        },
        formatarCracha(funcionario) {
            let novo = '';
            let tamanho = funcionario.cracha.length;
            if(funcionario.cracha.length < 14) {
                let resto = 14 - tamanho;
                for(let i = 0; i < resto; i++) {
                    novo += '0';
                }
            }            
            funcionario.crachaFormatado = novo+funcionario.cracha;
        },
        /**
         * 
         */
        listarCnpjs() { 
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = cacheEmpresa.centrosCustos;       
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
            this.validarCacheDados();
        },
        /**
         * 
         */
        listarCentrosCustos() {
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            cacheEmpresa.idCnpjSelecionado = this.idCnpjSelecionado;             
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => {     
                cacheEmpresa.centrosCustos = [];
                this.centrosCustos = resp.data;    
                resp.data.forEach(ct => {
                    cacheEmpresa.centrosCustos.push({...ct});
                });                    
                this.atualizarCacheEmpresa(cacheEmpresa);                                 
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        },
        // Dados filtrados na sessionStorage
        validarCacheDados() {
            let cacheDados = sessionStorage.getItem('CACHE_DADOS_CONTROLE_PONTO'); 
            // Esse atribuo foi definido no router.beforeEach em router.js
            if(window.urlAnteriorSelecionada == '/movimento/controle-ponto/marcacoes' && cacheDados != null) {         
                let dados = JSON.parse(cacheDados);         
                //this.idCnpjSelecionado = dados.idCnpjSelecionado;
                this.idCentroCustoSelecionado = dados.idCentroCustoSelecionado;  
                //this.centrosCustos = dados.centrosCustos;
                this.crachaNome = dados.crachaNome;
                this.ativo = dados.ativo;
                this.mesAno = new Date(dados.mesAno);          
                this.numPagina = dados.numPagina;
                this.periodosControle = dados.periodosControle;
                this.$refs.paginacao.atualizar(dados.qdtFuncionarios);      
                this.$refs.paginacao.paginarSemAtualizarDados(dados.numPagina);  
            } else {                
                sessionStorage.removeItem('CACHE_DADOS_CONTROLE_PONTO');
                this.limparDadosFuncionario();
            }
        },
        // Dados filtrados na sessionStorage
        atualizarCacheDados(qdtFuncionarios) {
            let cacheDados = {
                idCnpjSelecionado: this.idCnpjSelecionado,
                idCentroCustoSelecionado: this.idCentroCustoSelecionado,  
                centrosCustos: this.centrosCustos,
                crachaNome: this.crachaNome,
                ativo: this.ativo,
                mesAno: this.mesAno,          
                numPagina: this.numPagina,
                qdtFuncionarios: qdtFuncionarios,
                periodosControle: this.periodosControle,
            }
            sessionStorage.setItem('CACHE_DADOS_CONTROLE_PONTO', JSON.stringify(cacheDados));
        },    
    },
	created() {
        this.controlePontoService = new ControlePontoService();
        this.centroCustoService = new CentroCustoService();   
	},
	mounted() {	   
        let dados = this.getDadosRequisicao();   
        if(dados.usuario.nome == 'Suporte InfoKings' && dados.usuario.email == 'suporte@suporte.infokings') {
            this.suporteOnline = true;
        }
        this.criarRangeData();	
        this.listarCnpjs();
    },
    components: {
        'Paginacao': Paginacao,
        'AnalisePontoDuplicado': AnalisePontoDuplicado
    }
}
</script>

<style>

</style>